import React from "react";
import config from "config";
import Image from "components/Elements/Image/Image.tsx";
import Button from "../..//Elements/Button/Button.js";
import BrandedCoverUploader from "../../Reusable/BrandedCoverUploader/BrandedCoverUploader.js";
import ForBusinessOnlyModal from "../../Reusable/ForBusinessOnlyModal/ForBusinessOnlyModal.js";
import useMailSender from "../../../hooks/useMailSender.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";

import "./PopupContainer.scss";

const UploadBrandedCoverPopup = ({ children }) => {
  const { getTextByKey, getPath } = useContent();
  const { setModal } = useModal();
  const { isLoggedIn, isSubscribed, isPro, isBusiness, isPremium } = useUser();
  const { isMailSenderAndBusinessSubscriber, isMailSender } = useMailSender();
  const handleClick = () => {
    if (isMailSenderAndBusinessSubscriber()) {
      setModal({
        modal: BrandedCoverUploader,
      });
    } else if (isMailSender() && !isBusiness() && !isPremium()) {
      setModal({
        modal: ForBusinessOnlyModal,
      });
    } else if (isSubscribed() && isLoggedIn()) {
      window.location.href =
        config.baseurl + getPath() + "Profile_UserBranding.aspx";
    } else if (isLoggedIn()) {
      //if user is not business subscriber but loggedIn
      window.location.href = config.baseurl + getPath() + "plans";
    }
    // else if (isLoggedIn()) {
    //   //if user is not subscriber but logged in
    //   window.location.href =
    //     config.baseurl + getPath() + "Profile_UserBranding.aspx";
    // } else {
    //   //if user is not logged in
    //   setModal({
    //     modal: NotSubscriberModal,
    //   });
    // }
  };

  return (
    <div className="upload-branded-cover-container">
      <Image name="edit-background" alt="" title="" />
      <div className="title">
        {isMailSender() && isSubscribed()
          ? getTextByKey("update-default-cover-title")
          : getTextByKey("update-not-business-subscriber-cover-title")}
      </div>
      <div className="content-center">
        {isMailSender() && isSubscribed()
          ? getTextByKey("update-default-cover-description")
          : getTextByKey("update-not-business-subscriber-cover-description")}
      </div>
      <Button onClick={handleClick}>
        {isMailSender() && isSubscribed()
          ? getTextByKey("add-image")
          : getTextByKey("upgrade")}
      </Button>
    </div>
  );
};

export default UploadBrandedCoverPopup;
